import { gql } from '@apollo/client';

export const DETAILED_DATA_REPORT_FILTERS = gql`
  fragment detailedDataReportFilters on DetailedDataReportFilters {
    advertiserId
    lineItems
    rollUpType
    metricsTypes
  }
`;
